var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbar"},[_c('van-tabbar',{on:{"change":_vm.onChange},model:{value:(_vm.tabbarTempValue),callback:function ($$v) {_vm.tabbarTempValue=$$v},expression:"tabbarTempValue"}},[_c('van-tabbar-item',{attrs:{"icon":"cart-o"}},[_vm._v("提货")]),_c('van-tabbar-item',{attrs:{"icon":"search"}},[_vm._v("查询")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }